import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import { CKEditor } from '@ckeditor/ckeditor5-react';
import { ClassicEditor, Bold, Essentials, Heading, Indent, IndentBlock, Italic, Link, List, MediaEmbed, Paragraph, Table, Undo } from 'ckeditor5';
import 'ckeditor5/ckeditor5.css';
import { getAchievementListSvc, saveAchievementSvc, deleteAchievementSvc } from './achievementSlideSvc.js'

function AchievementsSlide(props) {
  const [ptmId, setPtmId] = useState(props.ptmId)
  const [text1, setText1] = useState('')
  const [text2, setText2] = useState('')
  const [text3, setText3] = useState('')
  const [text4, setText4] = useState('')
  const [text1Key, setText1Key] = useState(0)
  const [text2Key, setText2Key] = useState(0)
  const [text3Key, setText3Key] = useState(0)
  const [text4Key, setText4Key] = useState(0)

  const getAchievement = (pPtmId) => {
    getAchievementListSvc(pPtmId, cbAchievementRsp)
  }

  useEffect(() => {
    if (props.ptmId)
      getAchievement(props.ptmId);
  }, [props.ptmId])

  const cbAchievementRsp = async (data) => {
    let lstPtmAchievement = [];
    if (data.status == "Success") {
      lstPtmAchievement = data.lstPtmAchievement;
      await setText1(lstPtmAchievement[0]?.txt)
      setText1Key(Math.round(Math.random() * 99999))
      await setText2(lstPtmAchievement[1]?.txt)
      setText2Key(Math.round(Math.random() * 99999))
      await setText3(lstPtmAchievement[2]?.txt)
      setText3Key(Math.round(Math.random() * 99999))
      await setText4(lstPtmAchievement[3]?.txt)
      setText4Key(Math.round(Math.random() * 99999))
    } else {
      toast.error(data.message)
    }
  }

  const handleEditor1Change = (event, editor) => {
    const data = editor.getData();  // Get the formatted text from the editor
    setText1(data);  // Save it in the state
  };
  const handleEditor2Change = (event, editor) => {
    const data = editor.getData();  // Get the formatted text from the editor
    setText2(data);  // Save it in the state
  };
  const handleEditor3Change = (event, editor) => {
    const data = editor.getData();  // Get the formatted text from the editor
    setText3(data);  // Save it in the state
  };
  const handleEditor4Change = (event, editor) => {
    const data = editor.getData();  // Get the formatted text from the editor
    setText4(data);  // Save it in the state
  };

  const saveAchievements = () => {
    let ptmAchievement = []
    ptmAchievement.push({ ptmId: ptmId, txtOrderNo: 1, txt: text1 })
    ptmAchievement.push({ ptmId: ptmId, txtOrderNo: 2, txt: text2 })
    ptmAchievement.push({ ptmId: ptmId, txtOrderNo: 3, txt: text3 })
    ptmAchievement.push({ ptmId: ptmId, txtOrderNo: 4, txt: text4 })
    saveAchievementSvc(ptmAchievement, ptmId, cbSaveAchievement)
    // console.log(text1, text2, text3, text4)
  }

  const deleteAchievements = () => {
    deleteAchievementSvc(ptmId, cbSaveAchievement)
  }

  const cbSaveAchievement = (data) => {
    if (data.status == "Success") {
      getAchievement(data.ptmId);
      toast.success(data.message)
    } else {
      toast.error(data.message)
    }
  }


  return (
    <div>
      <ToastContainer autoClose={3000} hideProgressBar />
      <div  style={{ height: '90vh', overflowY: 'scroll' }}>
        <div>
          <CKEditor
            key={text1Key}
            editor={ClassicEditor}
            data={text1}
            onChange={handleEditor1Change} config={{
              toolbar: [
                'undo', 'redo', '|',
                'heading', '|', 'bold', 'italic', '|',
                'link', 'insertTable', 'mediaEmbed', '|',
                'bulletedList', 'numberedList', 'indent', 'outdent'
              ],
              plugins: [
                Bold,
                Essentials,
                Heading,
                Indent,
                IndentBlock,
                Italic,
                Link,
                List,
                MediaEmbed,
                Paragraph,
                Table,
                Undo
              ],
              initialData: '',

            }}
          />
        </div>
        <div style={{ marginTop: '2%' }}>
          <CKEditor
            key={text2Key}
            editor={ClassicEditor}
            data={text2}
            onChange={handleEditor2Change}
            config={{
              toolbar: [
                'undo', 'redo', '|',
                'heading', '|', 'bold', 'italic', '|',
                'link', 'insertTable', 'mediaEmbed', '|',
                'bulletedList', 'numberedList', 'indent', 'outdent'
              ],
              plugins: [
                Bold,
                Essentials,
                Heading,
                Indent,
                IndentBlock,
                Italic,
                Link,
                List,
                MediaEmbed,
                Paragraph,
                Table,
                Undo
              ],
              initialData: '',
            }}
          />
        </div>
        <div style={{ marginTop: '2%' }}>
          <CKEditor
            key={text3Key}
            editor={ClassicEditor}
            data={text3}
            onChange={handleEditor3Change}
            config={{
              toolbar: [
                'undo', 'redo', '|',
                'heading', '|', 'bold', 'italic', '|',
                'link', 'insertTable', 'mediaEmbed', '|',
                'bulletedList', 'numberedList', 'indent', 'outdent'
              ],
              plugins: [
                Bold,
                Essentials,
                Heading,
                Indent,
                IndentBlock,
                Italic,
                Link,
                List,
                MediaEmbed,
                Paragraph,
                Table,
                Undo
              ],
              initialData: '',
            }}
          />
        </div>
        <div style={{ marginTop: '2%' }}>
          <CKEditor
            key={text4Key}
            editor={ClassicEditor}
            data={text4}
            onChange={handleEditor4Change}
            config={{
              toolbar: [
                'undo', 'redo', '|',
                'heading', '|', 'bold', 'italic', '|',
                'link', 'insertTable', 'mediaEmbed', '|',
                'bulletedList', 'numberedList', 'indent', 'outdent'
              ],
              plugins: [
                Bold,
                Essentials,
                Heading,
                Indent,
                IndentBlock,
                Italic,
                Link,
                List,
                MediaEmbed,
                Paragraph,
                Table,
                Undo
              ],
              initialData: '',
            }}
          />
        </div>
      </div>
      <div className="col-sm-2 pull-right" style={{ marginTop: '1%' }}>
        <div className="col-sm-6 " >
          <button type="button" title="Save"
            className="btn btn-info" onClick={() => saveAchievements()}>Save</button>
        </div>
        <div className="col-sm-6 pull-right" >
          <button type="button" title="Delete All"
            className="btn btn-info" onClick={() => deleteAchievements()}>Delete</button>
        </div>
      </div>
    </div>
  )
}

export default AchievementsSlide